export const FOTT_VESSEL_NOMINATION_ACCESS_PERMISSION = "hasFottVesselNominationAccess";
export const DRY_BULK_VESSEL_NOMINATION_ACCESS_PERMISSION = "hasDryBulkVesselNominationAccess";
